"use client";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import styles from "../styles/Home.module.css";
// import { encryptData } from "helpers/encrypt";

type Slide = {
  image: string;
  title: string;
  subText: string;
  url: string;
  buttonText: string;
  alignment?: "left" | "center" | "right";
  imagePosition?: string;
}

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // async function checki(data: object) {
  //   const encData = encryptData(data);

  //   const response = await fetch("/api/gtk", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       data: encData,
  //     }),
  //   });

  //   const res = await response.json();
  //   console.log(res);
  // }

  useEffect(() => {
    // var data = { data: "A for apple" };
    // checki(data);
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slideData.length);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const alignmentClass = (alignment: string | undefined) => {
    switch (alignment) {
      case "left":
        return "justify-start text-left";
      case "right":
        return "justify-end text-right";
      default:
        return "justify-center text-center";
    }
  };

  return (
    <div className="w-full">
      {slideData.map((slide, index) => (
        <div
          key={slide.image}
          className="absolute top-0 left-0 bottom-0 right-0 w-full md:h-auto h-full -z-10 bg-cover bg-no-repeat transition-opacity duration-1000"
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundPosition: slide.imagePosition ?? "center",
            opacity: index === currentSlide ? 1 : 0,
          }}
        />
      ))}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30 -z-10"></div>
      <div
        className={`container z-40 text-white w-full flex ${alignmentClass(
          slideData[currentSlide].alignment,
        )}`}
      >
        <div>
          <h1 className="text-4xl mb-3">{slideData[currentSlide].title}</h1>
          <p className="mb-5 text-lg">{slideData[currentSlide].subText}</p>
          <a
            href={slideData[currentSlide].url}
            className="btn btn-lg btn-green"
          >
            {slideData[currentSlide].buttonText}
          </a>
        </div>
      </div>
      
    </div>
    // </section>
  );
}

export default Hero;

const slideData: Slide[] = [
  {
    image: "familyBanner.jpg",
    title: "Explore our best-selling products",
    subText: "",
    buttonText: "View Best Sellers",
    url: "/shop",
  },
  {
    image: "PowerBoxBanner.jpg",
    title: "All you need in one purchase",
    subText: "Better value, less hassle",
    buttonText: "View PowerBox",
    url: "/powerbox",
  },
  {
    image: "solarPanels.jpg",
    title: "Switch to Solar",
    subText: "",
    buttonText: "View Best Sellers",
    url: "/shop?category=Solar+Panel",
  },
  // {
  //   image: "StandardSolutionBanner.png",
  //   title: "The Complete Package, Just for You",
  //   subText: "",
  //   buttonText: "View Standard Packages",
  //   url: "/shop?category=Complete+Solution",
  // },
  // {
  //   image: "referralWoman.jpg",
  //   title: "Refer a Friend & Earn Some Cash",
  //   subText: "",
  //   buttonText: "Referral Program",
  //   url: "/shop",
  //   alignment: "left",
  // },
  {
    image: "EnergyAuditBanner.jpg",
    title: "Estimate Your Energy Needs",
    subText: "Let our free energy calculator guide you",
    buttonText: "View Energy Calculator",
    url: "/calculator",
  },
  // {
  //   image: "/banner2.jpg",
  //   title: "Switch to Solar",
  //   subText: "Enjoy 9% interest per annum",
  //   buttonText: "View Best Sellers",
  //   url: "/shop",
  // },
  // {
  //   image: "/banner3.jpg",
  //   title: "All you need in one purchase",
  //   subText: "Better value, less hassle",
  //   buttonText: "View PowerBox",
  //   url: "/powerbox-waitlist",
  // },
  // {
  //   image: "/banner4.jpg",
  //   title: "Get up to 10% off",
  //   subText: "on all purchases this season",
  //   buttonText: "View Best Sellers",
  //   url: "/shop",
  //   alignment: "left",
  // },
  // {
  //   image: "/banner5.jpg",
  //   title: "Everything you need.",
  //   subText: "One Standard Package",
  //   buttonText: "View Standard Packages",
  //   url: "/shop?category=Complete+Solution",
  // },
  // {
  //   // image: "/bg.webp",
  //   image: "/business.jpeg",
  //   title: "Cut Your Power Bills with Solar Energy",
  //   subText:
  //     "Switch to solar in 3 easy steps and zero upfront cost: Calculate > Pick Plan > Get Installed",
  //   buttonText: "Browse Special Offers",
  // },
  // {
  //   image: "/hero-img1.jpg",
  //   title: "Earnegy for All",
  //   subText: "Share the energy and earn rewards",
  //   buttonText: "View Referral Program",
  // },
  // {
  //   // image: "/hero-img2.jpg",
  //   image: "/family.jpeg",
  //   title: "Hot Picks",
  //   subText: "Explore our best-selling products",
  //   buttonText: "View Best Sellers",
  // },
];
